@if (isVisible) {
  <div id="importModal">
    <div class="modal-content">
      <div
        class="modal-header"
        style="display: flex; flex-direction: column; gap: 10px"
        >
        <h2 class="modal-title">Import from HQ</h2>
        <h3 class="modal-title">{{ sourceTournament?.name }}</h3>
      </div>
      <div style="display: flex; justify-content: space-between; margin: 0px 5px">
        <div class="modal-options">
          @if (showCoursesOption) {
            <label>
              <input type="checkbox" [(ngModel)]="includeCourses" />
              Include {{ sourceTournament?.coursesCount }}
              {{ sourceTournament?.coursesCount! > 1 ? "Courses" : "Course" }}
            </label>
          }
          @if (showCoursesOption && sourceCourses.length > 0) {
            <div
              style="margin-left: 24px; margin-top: 8px; color: #676a6c"
              >
              @for (course of sourceCourses; track course) {
                <div style="font-size: 0.9em">
                  {{ course.name }}
                  @if (course.shortName) {
                    <span>({{ course.shortName }})</span>
                  }
                </div>
              }
            </div>
          }
          @if (showPlayersOption) {
            <label>
              <input type="checkbox" [(ngModel)]="includePlayers" />
              Include Full Field from API ({{ sourceTournament?.playersCount }}
              Players)
            </label>
          }
        </div>
        @if (showPlayersOption && includePlayers) {
          <div class="modal-options">
            <label>
              <input type="checkbox" [(ngModel)]="includePointsRaceRankings" />
              Include Points Race Rankings
            </label>
            @if (includePointsRaceRankings) {
              <label>
                Points Race Name:
                <input
                  readonly
                  class="form-control"
                  type="text"
                  [(ngModel)]="pointsRaceName"
                  />
                </label>
              }
            </div>
          }
        </div>
        <div class="modal-body">
          <p style="margin: 15px 15px">
            @if (showCoursesOption && !showPlayersOption) {
              <span>
                Click <strong>Continue</strong> to import <strong>courses</strong> for
                <strong>{{ sourceTournament?.name }}</strong> from LPGA HQ.
              </span>
            }
            @if (showPlayersOption && !showCoursesOption) {
              <span>
                Click <strong>Continue</strong> to import <strong>players</strong> for
                <strong>{{ sourceTournament?.name }}</strong> from LPGA HQ.
              </span>
            }
            @if (showCoursesOption && showPlayersOption) {
              <span>
                Click <strong>Continue</strong> to import
                <strong>{{ sourceTournament?.name }}</strong> from LPGA HQ.
              </span>
            }
          </p>
        </div>
        <div class="modal-footer" style="display: flex; gap: 10px">
          <button
            type="button"
            class="btn btn-secondary"
            (click)="closeModal()"
            [disabled]="isImportingSignal?.()"
            >
            <i class="fa fa-times"></i> Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary"
            (click)="confirmImport()"
            [disabled]="isImportingSignal?.()"
            autofocus
            >
            @if (!isImportingSignal?.()) {
              <span
                ><i class="fa fa-download"></i> Continue</span
                >
            }
            @if (isImportingSignal?.()) {
              <span
                ><i class="fa fa-spinner fa-spin"></i> Importing...</span
                >
              }
            </button>
          </div>
        </div>
      </div>
    }
